import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  lighten,
  Skeleton,
  Typography,
} from '@mui/material';

type WalletSummaryCardProps = {
  title: string;
  value: number | string;
  description: string;
  subtitle?: string;
  color?: string;
  isLoading?: boolean;
};

export const WalletSummaryCard = ({
  data,
}: {
  data: WalletSummaryCardProps;
}) => {
  return (
    <Card
      sx={{
        width: '100%',
        px: 2,
        borderColor: data.color ? data.color : '#C8C8C8',
        backgroundColor: data.color ? lighten(data.color, 0.95) : 'inherit',
      }}>
      <CardHeader title={data.title} />
      <CardContent>
        <Typography variant="h6" fontWeight="bold">
          {data.isLoading ? (
            <Skeleton
              variant="text"
              animation="wave"
              width="100%"
              height={24}
            />
          ) : (
            data.value
          )}
        </Typography>
      </CardContent>
      <CardActions sx={{ justifyContent: 'space-between' }}>
        <Typography variant="body1">{data.description}</Typography>
        {data.subtitle && (
          <Typography variant="body2" color="textSecondary" ml="auto">
            {data.subtitle}
          </Typography>
        )}
      </CardActions>
    </Card>
  );
};
